<template>
  <div 
    class="page-title bg-me-primary-1 text-white"
    :style= "$vuetify.display.width <= 375 ? { 'padding-top': '20px', 'padding-bottom': '20px', 'margin-bottom': '0px' } : $vuetify.display.width <= 1440 ? { 'padding-top': '24px', 'padding-bottom': '24px', 'margin-bottom': '0px' } : $vuetify.display.width <= 1920 ? { 'padding-top': '30px', 'padding-bottom': '30px', 'margin-bottom': '0px' } : { 'padding-top': '30px', 'padding-bottom': '30px', 'margin-bottom': '0px' }">
    <div class="row">
      <div class="col-6">
        <h3>{{ main }}</h3>
      </div>
      <div class="col-6">
        <el-breadcrumb class="pa-0 float-right breadcrumb text-white">
          <el-breadcrumb-item :to="{ path: '/dashboard' }">
            <!-- <i class="fa fa-home f-16 p-l-1 p-r-1 text-white"> </i> -->
             <svg style="height: 18px; width: 18px;">
              <use href="@/assets/svg/icon-sprite.svg#home-icon"></use>
            </svg>
          </el-breadcrumb-item>
          <el-breadcrumb-item
            v-for="item in path"
            :key="item"
            :to="item.disabled ? `` : { path: item.href }"
            class="b-item-style"
          >
            {{ item.title }}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      default: "home",
    },
    main: {
      default: "",
    },
    path: {
      default: [],
    },
  },
  method: {
    home() {
      console.log("as");
      this.$router.push({ path: "/dashboard" });
    },
  },
};
</script>

<style>
/* .el-breadcrumb__item:last-child {
  color: var(--el-color-primary) !important;
} */
.b-item-style > span {
  color: white !important;
}
</style>
